import slice from './shipping.slice';
export { fetchScheduleByCartId, selectSchedule, setSchedule } from './shipping.slice';
export default slice.reducer;
